import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { StyledUserBalancesWrapper } from "../../../account/styledAccount";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import Notification from "../../../elements/notification/Notification";
import ExclusionCreateForm from "../../../elements/ServiceExclusions/New/ExclusionCreateForm";
import MaterialPagination from "../../../styles/materialPagination";
import ServiceExclusionFilter from "./ServiceExclusionFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ServiceExclusionList from "./ServiceExclusionList";

const ServiceExclusionContainer = ({ t }) => {
  const [exclusions, setExclusions] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "serviceExclusionsNew", false, true),
    "name": checkFilterItem(history, "name", null),
    "type": checkFilterItem(history, "type", null),
    "exclusionValues": checkFilterItem(history, "exclusionValues", null),
    "service.name": checkFilterItem(history, "service.name", null)
  });
  const [fetch, setFetch] = useState(false);

  const fetchData = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/service-exclusion-lists" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setExclusions(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchData();
  }, [filterData, fetch]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledUserBalancesWrapper>
        <div className="content-head service-exclusion-head">
          <ServiceExclusionFilter
            filterData={filterData}
            setFilterData={setFilterData}
            t={t}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
          <ExclusionCreateForm
            setFetch={setFetch}
            t={t}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ServiceExclusionList
          collection={exclusions}
          t={t}
          notification={notification}
          setFetch={setFetch}
          setNotification={setNotification}
        />
        {totalPageCount > 1  &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledUserBalancesWrapper>
    </>
  );
};

export default ServiceExclusionContainer;